module.exports = __webpack_public_path__ + "img/M3.587522b6.png";